import { Grid, Button, FormControl, FormLabel, RadioGroup, FormControlLabel, FormHelperText, Radio } from "@material-ui/core";
import HeaderModal from "../../../global/headerModal";
import ModalBase from "./../../../global/ModalBase";
import { makeStyles } from "@material-ui/core";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux"
import { selectClienteTarget, cambiarEstatusPaquete } from "../../../ducks/clientesDuck"
import { ToastMessage } from "../../../global/ToastMessage";
import { DialogMessage } from "../../../global/DialogMessage";
import { catRoles } from "../../../constant/catRoles"
import { usePermiso } from "../../../hooks/usePermiso"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import useCatalogos from "../../../hooks/useCatalogos"
import { esFinalizado } from "../../../utils/esFinalizado";
export const FCortizadorStyle = makeStyles((theme) => ({
    containerSpacing: {
        margin: "10px 0",
        padding: "1rem",
        maxHeight: "80vh"
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),

    },
    formControl: {
        margin: theme.spacing(3),
    },
    button: {
        margin: theme.spacing(1, 1, 0, 0),
    },
}));

const ModalFinalizar = () => {
    const { profile } = useSelector(store => store.logeo)
    const { cliente, referencia } = useSelector(store => store.cliente)
    const [permitido] = usePermiso({ location: "FK_AdministrarClientes_Finalizar", initialValue: false })
    const dispatch = useDispatch()
    const classes = FCortizadorStyle()
    const [open, setOpen] = useState()
    const catalogoFinalizado = useCatalogos("ProcessStatus/Cancellation")
    const [value, setValue] = useState('');
    const handleRadioChange = (event) => {
        setValue(event.target.value);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (value === '')
            return null
        DialogMessage.fire({
            title: `Marcar como finalizado`,
            text: `¿Esta seguro de marcar la referencia #${referencia} como finalizado?`,
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "" }))
                dispatch(cambiarEstatusPaquete({ IdPaquete: cliente?.paquete?.Id_Paquete, IdEstatusProceso: value })).then(Response => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema intentar mas tarde",
                        });
                        return null;
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "error",
                            title: Response.Message,
                        });
                        return null;
                    }
                    dispatch(selectClienteTarget({ cliente, referencia }))
                    handleClose()
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                })
            }
        })
    }
    const handleClose = () => {
        setOpen(false)
        setValue('')
    }
    const handleOpen = () => {
        setOpen(true)
        setValue('')
    }

    if (profile.Rol?.Id === catRoles.ADMINISTRADOR || permitido) return (
        <>
            <Button
                onClick={handleOpen}
                disabled={esFinalizado(cliente?.paquete?.CatEstatusProceso?.IdEstatusProceso)}
                variant="contained"
                color="primary"
            >
                Finalizar referencia
            </Button>
            <ModalBase classes={classes} open={open} onClose={handleClose}>
                <HeaderModal handleClose={handleClose} titulo={`Finalizar viaje`} />
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12}>
                        <form onSubmit={handleSubmit}>
                            <FormControl component="fieldset" className={classes.formControl}>
                                <FormLabel component="legend">Motivo de finalización</FormLabel>
                                <RadioGroup aria-label="finalizacion" name="finalizacion" value={value} onChange={handleRadioChange}>
                                    {
                                        catalogoFinalizado.map((valor, index) =>
                                            <FormControlLabel key={valor.IdEstatusProceso} value={`${valor.IdEstatusProceso}`} control={<Radio />} label={valor.Descripcion} />
                                        )
                                    }
                                </RadioGroup>
                                <Button disabled={(value === '')} type="submit" variant="contained" color="primary" className={classes.button}>
                                    APLICAR
                                </Button>
                            </FormControl>
                        </form>
                    </Grid>
                </Grid>
            </ModalBase>
        </>

    )
    return null
}
export default ModalFinalizar